import { render } from "./ProgressChart.vue?vue&type=template&id=0bc8b05e&scoped=true"
import script from "./ProgressChart.vue?vue&type=script&lang=js"
export * from "./ProgressChart.vue?vue&type=script&lang=js"

import "./ProgressChart.vue?vue&type=style&index=0&id=0bc8b05e&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc8b05e"]])

export default __exports__